import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as FieldActions from '../_actions/field';
import { Field } from '../_models';

export interface FieldState extends EntityState<Field> {
  loading: boolean;
  loaded: boolean;
  cropsLoaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<Field> = createEntityAdapter<Field>();

const initialState: FieldState = adapter.getInitialState({
  loading: false,
  loaded: false,
  cropsLoaded: false,
  error: null,
});

const fieldReducer = createReducer(
  initialState,

  on(FieldActions.loadFields, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  // Store fields with thin crops (i.e. crops: <{id}>[])
  on(FieldActions.loadFieldsThinCrops, (state) => ({
    ...state,
    loading: false,
    cropsLoaded: false,
    loaded: true,
  })),

  on(FieldActions.loadFieldsSuccess, (state, { fields }) =>
    adapter.setAll(fields, { ...state, loading: false, loaded: true, cropsLoaded: true })
  ),

  on(FieldActions.loadFieldsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(FieldActions.addFieldSuccess, (state, { field }) => adapter.addOne(field, state)),

  on(FieldActions.updateFieldSuccess, (state, { field }) => adapter.upsertOne(field, state)),

  on(FieldActions.deleteFieldSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    FieldActions.addFieldFailure,
    FieldActions.updateFieldFailure,
    FieldActions.deleteFieldFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FieldState | undefined, action: Action) {
  return fieldReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
